import React from 'react';

import PropTypes from 'prop-types';

import { BlockFormControl } from '../../css';
import { useLocalizedStringsContext } from '../../../../../../../context/LocalizedStringsContext';

import FormControlItem from './formControlItem';

const FormControlPanel = ({ id, formTypes, fetchData }) => {
  const {
    manageAccount: { accessControlFormsList }
  } = useLocalizedStringsContext();

  const updatedFormType =
    formTypes ||
    accessControlFormsList.reduce(
      (acc, current) => ({ ...acc, [current.key]: false }),
      {}
    );

  return (
    <>
      <BlockFormControl>
        {accessControlFormsList.map(itemData => (
          <FormControlItem
            data={itemData}
            id={id}
            formTypes={updatedFormType}
            fetchData={fetchData}
          />
        ))}
      </BlockFormControl>
    </>
  );
};

FormControlPanel.propTypes = {
  id: PropTypes.number.isRequired,
  formTypes: PropTypes.shape({
    disableBrp: PropTypes.bool,
    disableReferral: PropTypes.bool,
    disableWireless: PropTypes.bool,
    disableWireline: PropTypes.bool
  }).isRequired,
  fetchData: PropTypes.func.isRequired
};

export default FormControlPanel;
